import { useEffect } from 'react'

export const useReset = (setIsLoading) => {
  useEffect(() => {
    setIsLoading(false)
  }, [])
}
